import { createRouter, createWebHistory } from 'vue-router'

// Import views
import Home from '../views/Home.vue'
import Services from '../views/Services.vue'
import About from '../views/About.vue'
import Contact from '../views/Contact.vue'
import Gallery from '../views/Gallery.vue'

const routes = [
  { 
    path: '/', 
    name: 'Home',
    component: Home,
    meta: { title: 'Home - CW Home Improvements' }
  },
  { 
    path: '/services', 
    name: 'Services',
    component: Services,
    meta: { title: 'Services - CW Home Improvements' }
  },
  { 
    path: '/about', 
    name: 'About',
    component: About,
    meta: { title: 'About Us - CW Home Improvements' }
  },
  { 
    path: '/gallery', 
    name: 'Gallery',
    component: Gallery,
    meta: { title: 'Gallery - CW Home Improvements' }
  },
  { 
    path: '/contact', 
    name: 'Contact',
    component: Contact,
    meta: { title: 'Contact Us - CW Home Improvements' }
  },
  // Catch all route for 404
  { 
    path: '/:pathMatch(.*)*', 
    name: 'NotFound',
    component: () => import('../views/Home.vue'),
    meta: { title: 'Page Not Found - CW Home Improvements' }
  }
]

const router = createRouter({
  history: createWebHistory(),
  mode: 'history',
  routes
})

// Navigation guard to update page title
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router 